import React, { FC, ReactNode } from 'react';
import getClassName from 'src/common/utils/getClassName';
import s from './Modal.module.scss';

type BodyProps = {
  children: ReactNode;
  classNameModifier?: string;
};

const Body: FC<BodyProps> = ({ children, classNameModifier = '' }) => (
  <div className={getClassName(s, 'body', classNameModifier)}>{children}</div>
);

export default Body;
